<template>
  <div
    id="cursor"
    v-if="name.length > 0"
    class="hidden lg:block text-white dark:text-white mix-exclusion fixed whitespace-nowrap pointer-events-none text-xs uppercase transform -translate-x-1/2 -translate-y-1/2 z-50"
    :style="{ left: posX + 'px', top: posY + 'px' }"
  >
    {{ name }}
  </div>
</template>

<script>
export default {
  props: {
    name: String,
  },
  data() {
    return {
      posX: 0,
      posY: 0,
    };
  },
  mounted() {
    window.addEventListener("mousemove", this.mousePos);
  },
  methods: {
    mousePos(event) {
      this.posX = event.clientX;
      this.posY = event.clientY;
    },
  },
};
</script>

<style scoped></style>
